/**
 * @generated SignedSource<<a1d509d05a30a9a8107557119323a25b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrderListRow_order$data = {
  readonly adminComment: string | null;
  readonly id: string;
  readonly name: string;
  readonly orderNr: string | null;
  readonly pack: {
    readonly id: string;
  } | null;
  readonly priceAdvancePayment: number | null;
  readonly priceTotal: number;
  readonly time: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"EntityTableRow_entity" | "OrderStatus_order" | "OwnerWithEmailLink_order">;
  readonly " $fragmentType": "OrderListRow_order";
};
export type OrderListRow_order$key = {
  readonly " $data"?: OrderListRow_order$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrderListRow_order">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrderListRow_order",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "orderNr",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "time",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priceTotal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priceAdvancePayment",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "adminComment",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Package",
      "kind": "LinkedField",
      "name": "pack",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EntityTableRow_entity"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OwnerWithEmailLink_order"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OrderStatus_order"
    }
  ],
  "type": "Order",
  "abstractKey": null
};
})();

(node as any).hash = "a8ba135263ff6f6123d8d53b0b27654b";

export default node;
